const step_up = {
    verify_your_identity: 'Verifique a sua identidade',
    choose_method_description: 'Para continuar, confirme que é você com um dos seguintes métodos.',
    password: 'Palavra-passe',
    password_description: 'Introduza a palavra-passe da sua conta',
    enter_password_description: 'Introduza a palavra-passe da sua conta para continuar.',
    enter_verification_code_description: 'Introduza o código de verificação enviado para {{identifier}}.',
    subject_proof_description: 'Para continuar, confirme que é você através de uma conta associada à sua. Depois, poderá configurar um método de verificação.',
    subject_mismatch: 'A conta não corresponde',
    subject_mismatch_description: 'A conta que utilizou não está associada à sua conta. Utilize uma conta associada e, se necessário, mude de conta no fornecedor.',
    no_method_available: 'Nenhum método de verificação disponível',
    no_method_available_description: 'A sua conta não tem nenhum método que possa concluir esta verificação. Contacte o seu administrador para obter assistência.',
};
export default Object.freeze(step_up);
